import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "liga-float-bar" }
const _hoisted_2 = {
  key: 1,
  class: "liga-float-spacer",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "liga-float-title-pill" }
const _hoisted_4 = { class: "liga-float-title-text" }
const _hoisted_5 = { class: "ios-unread-icon-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "ios-unread-badge ios-unread-badge--on-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, {
    class: _normalizeClass(["page-header liga-float-header ion-no-border", { 'page-header--scrolled': _ctx.scrolled, 'page-header--no-menu': !_ctx.showMenuButton }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_toolbar, { class: "page-header-toolbar" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.showMenuButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "liga-float-circle menu-btn",
                  "aria-label": "Меню",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
            ]),
            (_ctx.showMessenger)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "liga-float-circle messenger-btn",
                  "aria-label": "Liga.Chat",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openMessenger && _ctx.openMessenger(...args)))
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ion_icon, { icon: _ctx.chatbubbleEllipsesOutline }, null, 8, ["icon"]),
                    (_ctx.unreadLabel)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.unreadLabel), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: "liga-float-circle settings-btn",
                  "aria-label": "Настройки",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSettings && _ctx.openSettings(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.settingsOutline }, null, 8, ["icon"])
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}